// CNA Skilled Tasks section questionnaire constants
export enum CNASkilledTasksQuestionnaireItem {
  // Task questions
  CNA_SKILLED_TASKS_BATHING_QUESTION = 'cna-skilled-tasks/bathing/question',
  CNA_SKILLED_TASKS_BATHING_NOTES = 'cna-skilled-tasks/bathing/notes',
  CNA_SKILLED_TASKS_BRACES_SPLINTS_STOCKINGS_QUESTION = 'cna-skilled-tasks/braces-splints-stockings/question',
  CNA_SKILLED_TASKS_BRACES_SPLINTS_STOCKINGS_NOTES = 'cna-skilled-tasks/braces-splints-stockings/notes',
  CNA_SKILLED_TASKS_BRACES_SPLINTS_STOCKINGS_ADDITIONAL = 'cna-skilled-tasks/braces-splints-stockings/question-a',
  CNA_SKILLED_TASKS_DRESSING_QUESTION = 'cna-skilled-tasks/dressing/question',
  CNA_SKILLED_TASKS_DRESSING_NOTES = 'cna-skilled-tasks/dressing/notes',
  CNA_SKILLED_TASKS_EATING_QUESTION = 'cna-skilled-tasks/eating/question',
  CNA_SKILLED_TASKS_EATING_NOTES = 'cna-skilled-tasks/eating/notes',
  CNA_SKILLED_TASKS_TUBE_FEEDINGS_QUESTION = 'cna-skilled-tasks/tube-feedings/question',
  CNA_SKILLED_TASKS_TUBE_FEEDINGS_NOTES = 'cna-skilled-tasks/tube-feedings/notes',
  CNA_SKILLED_TASKS_MEDICATION_QUESTION = 'cna-skilled-tasks/medication/question',
  CNA_SKILLED_TASKS_MEDICATION_NOTES = 'cna-skilled-tasks/medication/notes',
  CNA_SKILLED_TASKS_MOBILITY_QUESTION = 'cna-skilled-tasks/mobility/question',
  CNA_SKILLED_TASKS_MOBILITY_NOTES = 'cna-skilled-tasks/mobility/notes',
  CNA_SKILLED_TASKS_MOBILITY_ADDITIONAL = 'cna-skilled-tasks/mobility/question-a',
  CNA_SKILLED_TASKS_MEAL_PREP_QUESTION = 'cna-skilled-tasks/meal-prep/question',
  CNA_SKILLED_TASKS_MEAL_PREP_NOTES = 'cna-skilled-tasks/meal-prep/notes',
  CNA_SKILLED_TASKS_GROOMING_QUESTION = 'cna-skilled-tasks/grooming/question',
  CNA_SKILLED_TASKS_GROOMING_NOTES = 'cna-skilled-tasks/grooming/notes',
  CNA_SKILLED_TASKS_GROOMING_ADDITIONAL = 'cna-skilled-tasks/grooming/question-a',
  CNA_SKILLED_TASKS_SKIN_CARE_APPLICATION_QUESTION = 'cna-skilled-tasks/skin-care-application/question',
  CNA_SKILLED_TASKS_SKIN_CARE_APPLICATION_NOTES = 'cna-skilled-tasks/skin-care-application/notes',
  CNA_SKILLED_TASKS_SKIN_CARE_APPLICATION_ADDITIONAL = 'cna-skilled-tasks/skin-care-application/question-a',
  CNA_SKILLED_TASKS_SKIN_CARE_QUESTION = 'cna-skilled-tasks/skin-care/question',
  CNA_SKILLED_TASKS_SKIN_CARE_NOTES = 'cna-skilled-tasks/skin-care/notes',
  CNA_SKILLED_TASKS_SKIN_CARE_ADDITIONAL = 'cna-skilled-tasks/skin-care/question-a',
  CNA_SKILLED_TASKS_ROM_EXERCISE_QUESTION = 'cna-skilled-tasks/rom-exercise/question',
  CNA_SKILLED_TASKS_ROM_EXERCISE_NOTES = 'cna-skilled-tasks/rom-exercise/notes',
  CNA_SKILLED_TASKS_RESPIRATORY_CARE_QUESTION = 'cna-skilled-tasks/respiratory-care/question',
  CNA_SKILLED_TASKS_RESPIRATORY_CARE_NOTES = 'cna-skilled-tasks/respiratory-care/notes',
  CNA_SKILLED_TASKS_OXYGEN_THERAPY_QUESTION = 'cna-skilled-tasks/oxygen-therapy/question',
  CNA_SKILLED_TASKS_OXYGEN_THERAPY_NOTES = 'cna-skilled-tasks/oxygen-therapy/notes',
  CNA_SKILLED_TASKS_ORAL_SUCTIONING_QUESTION = 'cna-skilled-tasks/oral-suctioning/question',
  CNA_SKILLED_TASKS_ORAL_SUCTIONING_NOTES = 'cna-skilled-tasks/oral-suctioning/notes',
  CNA_SKILLED_TASKS_BOWEL_FREQUENCY_QUESTION = 'cna-skilled-tasks/bowel-frequency/question',
  CNA_SKILLED_TASKS_BOWEL_FREQUENCY_NOTES = 'cna-skilled-tasks/bowel-frequency/notes',
  CNA_SKILLED_TASKS_BOWEL_HYGIENE_QUESTION = 'cna-skilled-tasks/bowel-hygiene/question',
  CNA_SKILLED_TASKS_BOWEL_HYGIENE_NOTES = 'cna-skilled-tasks/bowel-hygiene/notes',
  CNA_SKILLED_TASKS_BOWEL_ELIMINATION_QUESTION = 'cna-skilled-tasks/bowel-elimination/question',
  CNA_SKILLED_TASKS_BOWEL_ELIMINATION_NOTES = 'cna-skilled-tasks/bowel-elimination/notes',
  CNA_SKILLED_TASKS_BOWEL_PROGRAM_QUESTION = 'cna-skilled-tasks/bowel-program/question',
  CNA_SKILLED_TASKS_BOWEL_PROGRAM_NOTES = 'cna-skilled-tasks/bowel-program/notes',
  CNA_SKILLED_TASKS_CATHETER_CARE_QUESTION = 'cna-skilled-tasks/catheter-care/question',
  CNA_SKILLED_TASKS_CATHETER_CARE_NOTES = 'cna-skilled-tasks/catheter-care/notes',
  CNA_SKILLED_TASKS_MENSES_QUESTION = 'cna-skilled-tasks/menses/question',
  CNA_SKILLED_TASKS_MENSES_NOTES = 'cna-skilled-tasks/menses/notes',
  CNA_SKILLED_TASKS_URINARY_HYGIENE_QUESTION = 'cna-skilled-tasks/urinary-hygiene/question',
  CNA_SKILLED_TASKS_URINARY_HYGIENE_NOTES = 'cna-skilled-tasks/urinary-hygiene/notes',
  CNA_SKILLED_TASKS_POSITIONING_QUESTION = 'cna-skilled-tasks/positioning/question',
  CNA_SKILLED_TASKS_POSITIONING_NOTES = 'cna-skilled-tasks/positioning/notes',
  CNA_SKILLED_TASKS_TRANSFERS_QUESTION = 'cna-skilled-tasks/transfers/question',
  CNA_SKILLED_TASKS_TRANSFERS_NOTES = 'cna-skilled-tasks/transfers/notes',
  CNA_SKILLED_TASKS_VITALS_PHYSICIAN_QUESTION = 'cna-skilled-tasks/vitals-physician/question',
  CNA_SKILLED_TASKS_VITALS_PHYSICIAN_NOTES = 'cna-skilled-tasks/vitals-physician/notes',
  CNA_SKILLED_TASKS_VITALS_NURSE_QUESTION = 'cna-skilled-tasks/vitals-nurse/question',
  CNA_SKILLED_TASKS_VITALS_NURSE_NOTES = 'cna-skilled-tasks/vitals-nurse/notes'
}
